
import Vue from 'vue';
import { ACTIONS } from '@/constants/actions';
import { CommonPaginationResponseLink, PaginatorData } from '@/interfaces/common.interface';

export default Vue.extend({
  name: 'Paginator',
  props: { paginationData: Object as () => PaginatorData },
  methods: {
    getNextPageData(item: CommonPaginationResponseLink): void {
      if (item.label.includes('بعدی') || item.label.includes('قبلی')) {
        const { dispatch } = this.$store;
        dispatch(ACTIONS.books.getNextPageData, { url: item.url });
      } else {
        const requestedPageNumber = Number(item.label);
        if (
          Number.isInteger(requestedPageNumber) &&
          requestedPageNumber !== this.paginationData.currentPage
        ) {
          const { dispatch } = this.$store;
          dispatch(ACTIONS.books.getNextPageData, { url: item.url });
        }
      }
    },
    pageSelected(item: CommonPaginationResponseLink): void {
      this.$emit('pageSelect', item.url);
    }
  }
});
